<template>
    <div>
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div class="ui inverted dimmer transition" :class="{'active': !is_initialized}">
            <div class="ui text loader">
                {{ $t('ui.general.initializing') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OperationsLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.$store.dispatch('provider/operations_module/fetch_staffs')
            await new Promise(resolve => {
                this.is_initialized = true
                this.$noty.information(
                    this.$t("ui.page_titles.provider_operations") + ' ' +
                    this.$t('ui.general.initialize_complete')
                , 300)
                resolve()
            })
        },
    },
    components: {
    }
}
</script>
